import Vue from 'vue'
import Router from 'vue-router'

import Home from './pages/home/index'
import DigitalChina from './pages/home/index-china'
import Science from './pages/science/information'
import Success from './pages/science/success'

Vue.use(Router)

const routes = [
    {
        path: '/404',
    },
    {
        path: '/home',
        component: Home
    },
    {
        path: '/science',
        component: Science
    },
    {
        path: '/digital-china',
        component: DigitalChina
    },
    {
        path: '/success',
        component: Success
    },
    {
        path: '/',
        component: Home
    }
]

export default new Router({
    mode: 'hash',
    routes
})
